import React, { useState, useEffect } from "react";
import SideBar from "./SideBar";
import axiosClient from "../axios";
import loader from "../assets/images/loader.gif";
import { ReactComponent as Edit } from "../assets/images/edit.svg";
import Dialog from "@mui/material/Dialog";
import {useNavigate} from "react-router-dom";

import "../assets/css/profile.css";
import "../assets/css/userTable.css";

const UserPartnerLimitData = () => {
  const [partnerData, setPartnerData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [editId, setEditId] = useState("");
  const [editData, setEditData] = useState({});

  const navigate = useNavigate();
 

  const getUserPartnerLimitData = async () => {
    setIsLoading(true);
    await axiosClient
      .get(`/userPartnerLimitData`)
      .then((res) => {
        setPartnerData(res?.data?.response);
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => setIsLoading(false));
  };

  const handleDelete = () => {
    setOpen(false);
    setEditData({});
  };

  const handleEdit = (id) => {
    let data = {
      id: editId,
      transaction_limit: editData?.transaction_limit,
      amount_limit: editData?.amount_limit,
      user_id:editData?.userId,
      partner_id:editData?.partner_id
    };
    setOpen(false);

   
    setIsLoading(true);
    axiosClient
      .post(`/updateUserPartnerData`, data)
      .then(async (res) => {
        await getUserPartnerLimitData();
        alert(res.data.message);
        setEditData({});
      })
      .catch((error) => {
        console.log("error", error);
        alert("Some technincal Issue");
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    getUserPartnerLimitData();
  }, []);

  return (
    <>
      <SideBar handleSideBar={true} activeTab={"users"} />
      <div className="screen">
        <div className="heading-container">
          <h2>User Partner Limit Data </h2>

          {/* <button className="partner-limit-page">Partner Limit Page</button> */}
        </div>

        <div className="profileInfoBox table">
          {isLoading ? (
            <div className="loaderImage">
              <img src={loader} alt="loader" />
            </div>
          ) : (
            <>
              {partnerData?.length == 0 ? (
                <p> No Data Found</p>
              ) : (
                <div style={{ width: "100%" }} className="container app-body">
                  <div className="tabel-scrol">
                    <table id="users">
                      <thead>
                        <tr>
                          <th>S.NO.</th>
                          <th>Partner Name</th>

                          <th>User Name</th>
                          <th>User Email</th>
                          <th>User Id</th>

                          <th>Transaction Limit</th>
                          <th>Amount Limit</th>
                          <th>Edit</th>
                        </tr>
                      </thead>
                      {partnerData?.map((val, key) => {
                        return (
                          <tbody key={key}>
                            <tr>
                              <td>{key + 1}</td>
                              <td>{val?.partner_id?.name}</td>

                              <td>{val?.user_id?.name}</td>
                              <td>{val?.user_id?.emailId}</td>
                              <td style={{ cursor: "pointer" ,color:"blue"}} onClick={() => navigate(`/users/transaction/${val?.user_id?._id}`)}>{val?.user_id?._id}</td>

                              <td>{val?.transaction_limit || 0}</td>
                              <td>{val?.amount_limit || 0}</td>

                              <td>
                                {
                                  <Edit
                                    className="whiteRound"
                                    onClick={() => {
                                      setOpen(true);
                                      setEditData({
                                        transaction_limit:val?.transaction_limit || 0,
                                        amount_limit: val?.amount_limit || 0,
                                        userName: val?.user_id?.name,
                                        userId: val?.user_id?._id,
                                        partner_id: val?.partner_id?._id,
                                        partner_name: val?.partner_id?.name
                                      });
                                      setEditId(val?._id);
                                    }}
                                  />
                                }
                              </td>
                            </tr>
                          </tbody>
                        );
                      })}
                    </table>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <Dialog open={open} onClose={() => handleDelete()} className="dialogs">
        <div className="categoryEditBox">
          <h3>Edit Data</h3>

          <div className="pRelative w300">
            <label htmlFor="user_name">UserName</label>
            <input
              type="text"
              name="user_name"
              disabled
              placeholder="Transaction Limit "
            //   onChange={(e) => {
            //     setEditData({
            //       ...editData,
            //       transaction_limit: Number(e.target.value),
            //     });
            //   }}
              className="inputTag categoryInput"
              value={editData?.userName}
            //   onWheel={(e) => e.target.blur()}
            />
          </div>

          <div className="pRelative w300">
            <label htmlFor="partner_name">Partner Name</label>
            <input
              type="text"
              name="partner_name"
              disabled
              placeholder="Transaction Limit "
              className="inputTag categoryInput"
              value={editData?.partner_name}
         
            />
          </div>

          <div className="pRelative w300">
            <label htmlFor="transaction_limit">Transaction Limit</label>
            <input
              type="number"
              name="transaction_limit"
              placeholder="Transaction Limit "
              onChange={(e) => {
                setEditData({
                  ...editData,
                  transaction_limit: Number(e.target.value),
                });
              }}
              className="inputTag categoryInput"
              value={editData?.transaction_limit}
              onWheel={(e) => e.target.blur()}
            />
          </div>
          <div className="pRelative w300">
            <label htmlFor="amount_limit">Amount Limit</label>
            <input
              type="number"
              name="amount_limit"
              placeholder="Amount Limit"
              onChange={(e) => {
                setEditData({
                  ...editData,
                  amount_limit: Number(e.target.value),
                });
              }}
              value={editData?.amount_limit}
              className="inputTag categoryInput"
              onWheel={(e) => e.target.blur()}
            />
          </div>
          <div className="editButton" onClick={() => handleEdit()}>
            Edit
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default UserPartnerLimitData;
